import React from "react";
import { Provider } from "react-redux";
import GlobalStyles from "@iso/assets/styles/globalStyle";
import { store } from "./redux/store";
import Boot from "./redux/boot";
import Routes from "./router";
import AppProvider from "./AppProvider";

const run = () => {
  if (process.env.REACT_APP_MODE === "production") {
    console.log = function () {};
  }
};

const App = () => (
  <Provider store={store}>
    <AppProvider>
      <>
        <GlobalStyles />
        <Routes />
      </>
    </AppProvider>
  </Provider>
);

run();
Boot()
  .then(() => App())
  .catch((error) => console.error(error));

export default App;

